import React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "../lib/cn";

export interface TabProps {
  eventKey: string;
  title: React.ReactNode;
  disabled?: boolean;
  children: React.ReactNode;
}

interface TabsProps {
  id?: string;
  activeKey: string;
  onSelect?: (key: string | null) => void;
  className?: string;
  ariaLabel?: string;
  children: React.ReactNode;
}

export const Tab: React.FC<TabProps> = () => null;

export const Tabs = ({ id, activeKey, onSelect, className, ariaLabel = "탭 메뉴", children }: TabsProps) => {
  const tabs = React.Children.toArray(children).filter(
    (child): child is React.ReactElement<TabProps> => React.isValidElement<TabProps>(child),
  );

  return (
    <TabsPrimitive.Root
      id={id}
      value={activeKey}
      onValueChange={(value) => onSelect?.(value)}
      className={cn("ui-tabs", className)}
    >
      <TabsPrimitive.List className="ui-tabs-list" aria-label={ariaLabel}>
        {tabs.map((tab) => (
          <TabsPrimitive.Trigger
            key={tab.props.eventKey}
            value={tab.props.eventKey}
            disabled={tab.props.disabled}
            className="ui-tabs-trigger"
          >
            {tab.props.title}
          </TabsPrimitive.Trigger>
        ))}
      </TabsPrimitive.List>
      {tabs.map((tab) => (
        <TabsPrimitive.Content key={tab.props.eventKey} value={tab.props.eventKey} className="ui-tabs-content">
          {tab.props.children}
        </TabsPrimitive.Content>
      ))}
    </TabsPrimitive.Root>
  );
};

export default Tabs;
